import TypicalRoles from "./TargetUsers/TypicalRoles";
import SizeOfChurch from "./TargetUsers/SizeOfChurch";
import CallToAction from "./TargetUsers/CallToAction";

const TargetUsers = () => {
  return (
    <>
      <TypicalRoles />

      <SizeOfChurch />

      <CallToAction />
    </>

  );
};

export default TargetUsers;
